import { render, staticRenderFns } from "./InfoParent.vue?vue&type=template&id=78c8aa1d&lang=pug&"
import script from "./InfoParent.vue?vue&type=script&lang=js&"
export * from "./InfoParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports